interface ILocalStore {
    //LastRegionID: number;
    //LastOwnerID: number;
    LastEnvUnitID: number;
    Language: string;
    SelectedUnits: number[];
    getTablesCollFilter(table: string): number[];
    setTablesCollFilter(table: string, cols: number[]): void;
}

type TablesCollFilterType = Record<string, number[]>;

const AppLocalStore: ILocalStore = {
    get LastEnvUnitID() {
        const value = window.localStorage.getItem('LastEnvUnitID');
        if (value) return parseInt(value);
        return -1;
    },
    set LastEnvUnitID(rootUnitID: number) {
        window.localStorage.setItem('LastEnvUnitID', String(rootUnitID));
    },

    // get LastRegionID() {
    //     const value = window.localStorage.getItem('LastRegionID');
    //     if (value)
    //         return parseInt(value);
    //     return -1;
    // },
    // set LastRegionID(regionID: number) {
    //     window.localStorage.setItem('LastRegionID', String(regionID));
    // },
    //
    // get LastOwnerID() {
    //     const value = window.localStorage.getItem('LastOwnerID');
    //     if (value)
    //         return parseInt(value);
    //     return -1;
    // },
    // set LastOwnerID(ownerID: number) {
    //     window.localStorage.setItem('LastOwnerID', String(ownerID));
    // },

    get Language(): string {
        const value = window.localStorage.getItem('Language');
        if (value)
            return value;
        const lang = navigator.language.split("-")[0].toUpperCase();
        AppLocalStore.Language = lang;
        return lang;
    },
    set Language(language: string) {
        window.localStorage.setItem('Language', language);
    },

    get SelectedUnits(): number[] {
        const value: string = localStorage.getItem('SelectedUnits');
        if (value) return value.split(',').map((x) => parseInt(x));
        return [-1];
    },
    set SelectedUnits(units: number[]) {
        window.localStorage.setItem('SelectedUnits', String(units));
    },

    getTablesCollFilter(table: string): number[] {
        const value: string = localStorage.getItem('TablesCollFilter');
        if (!value) window.localStorage.setItem('TablesCollFilter', JSON.stringify({}));
        const obj = (JSON.parse(value) as TablesCollFilterType) ?? {};
        const res = obj[table];
        if (res) return res;
        AppLocalStore.setTablesCollFilter(table, []);
        return [];
    },
    setTablesCollFilter(table: string, cols: number[]): void {
        const current: string = localStorage.getItem('TablesCollFilter');
        const obj = JSON.parse(current) as TablesCollFilterType;
        window.localStorage.setItem('TablesCollFilter', JSON.stringify({ ...obj, [table]: cols }));
    },
};

export function readLocalJson<T>(key: string, fallback: T, isValid?: (value: unknown) => boolean): T {
    try {
        const raw = window.localStorage.getItem(key);
        if (raw == null) {
            return fallback;
        }
        const parsed = JSON.parse(raw) as unknown;
        if (isValid && !isValid(parsed)) {
            return fallback;
        }
        return parsed as T;
    } catch {
        return fallback;
    }
}

export function writeLocalJson(key: string, value: unknown): void {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
        // ignore quota / privacy mode
    }
}

export default AppLocalStore;
